module.exports = __webpack_public_path__ + "img/chevron-right--pink.ca14ec51.svg";